(function() { window.GUID_43291329_1dca_44c4_9389_9ec054b60c8a = { getGuid: function() { return "43291329-1dca-44c4-9389-9ec054b60c8a"; } }; })();
var CS;
(function (CS) {
    class LazyLoader {
        constructor(params) {
            this.debug = false;
            this.requestCounter = 0;
            if (params.debug != undefined) {
                this.debug = params.debug;
            }
            if (params.filter != undefined) {
                this.Filter = params.filter;
            }
            if (params.$skeletonUI != undefined) {
                this.$skeletonUI = params.$skeletonUI;
            }
            this.scrollEventTriggerMargin = (params.scrollEventTriggerMargin != undefined) ? params.scrollEventTriggerMargin : 0;
            this.LoadURL = params.loadURL;
            this.loadElementsClass = params.loadElementsClass;
            this.GetQuantity = params.getQuantity;
            this.$loadElementsContainer = params.$loadElementsContainer;
            this.$scrollingContainer = params.$scrollingContainer;
            this.$triggerElement = params.$triggerElement;
            this.$triggerElement.attr("id", `${params.loadElementsClass}-lazyloader-trigger`);
            this.OnElementsObtained = params.onElementsObtained;
        }
        Start() {
            this.SkipQuantity = $(this.loadElementsClass).length;
            this.getElements();
        }
        Stop() {
            this.$scrollingContainer.off("scroll.lazyloader");
            this.$triggerElement.remove();
        }
        getElements() {
            let me = this, data = {
                quantityToGet: this.GetQuantity,
                quantityToSkip: this.SkipQuantity,
                filter: this.Filter,
            };
            if (me.debug) {
                console.info("Loading elements");
            }
            if (this.dataIsValid()) {
                CompuSport.Ajax.Get(this.LoadURL, data, function (response) {
                    let $response = $(response), responseElementsCount = 0;
                    if (me.debug) {
                        console.groupCollapsed("LazyLoader");
                        console.groupCollapsed("Data");
                        console.info(data);
                        console.groupEnd();
                        console.groupCollapsed("Response");
                        console.info(response);
                        console.groupEnd();
                    }
                    if (me.requestCounter == 0) {
                        if (me.$skeletonUI != undefined) {
                            me.$skeletonUI.remove();
                        }
                    }
                    me.$triggerElement.remove();
                    if ($response.length > 0) {
                        for (var i = 0; i < $response.length; i++) {
                            let $element = $($response[i]);
                            if ($element.hasClass(me.loadElementsClass)) {
                                me.SkipQuantity++;
                                responseElementsCount++;
                            }
                        }
                        if (me.debug) {
                            console.groupEnd();
                        }
                        if (me.OnElementsObtained) {
                            me.OnElementsObtained.call(me, $response);
                        }
                        if (responseElementsCount >= me.GetQuantity) {
                            me.bindScrollingEvent();
                        }
                        else if (me.$skeletonUI != undefined) {
                            me.$skeletonUI.remove();
                        }
                    }
                    else if (me.$skeletonUI != undefined) {
                        me.$skeletonUI.remove();
                    }
                    me.requestCounter++;
                });
            }
        }
        bindScrollingEvent() {
            let me = this;
            me.$loadElementsContainer.append(me.$skeletonUI);
            me.$loadElementsContainer.append(me.$triggerElement);
            let triggerElementHeight = me.$triggerElement.outerHeight(), skeletonElementHeight = (me.$skeletonUI != undefined && me.$skeletonUI.length > 0) ? me.$skeletonUI.outerHeight() : 0, windowHeight = $(window).height(), scrollingContainerHeight = me.$loadElementsContainer.height(), triggerEventScrollTop = scrollingContainerHeight + triggerElementHeight - me.scrollEventTriggerMargin - skeletonElementHeight;
            if (me.debug) {
                console.info("scrollingContainerHeight", scrollingContainerHeight);
                console.info("triggerElementHeight", triggerElementHeight);
                console.info("skeletonElementHeight", skeletonElementHeight);
                console.info("windowHeight", windowHeight);
                console.info("triggerEventScrollTop", triggerEventScrollTop);
            }
            let i = 0;
            me.$scrollingContainer.bind("scroll.lazyloader", function () {
                let triggerElementScrollTop = $(this).scrollTop(), currentScrollTop = triggerElementScrollTop + windowHeight;
                if (me.debug) {
                    if (i % 10 == 0) {
                        console.info("currentScrollTop", currentScrollTop);
                    }
                    i++;
                }
                if (currentScrollTop >= triggerEventScrollTop) {
                    me.$scrollingContainer.off("scroll.lazyloader");
                    me.getElements();
                }
            });
        }
        dataIsValid() {
            return this.LoadURL != undefined && this.GetQuantity != undefined && this.SkipQuantity != undefined && this.Filter != undefined;
        }
    }
    CS.LazyLoader = LazyLoader;
})(CS || (CS = {}));

//# sourceMappingURL=cs.lazyloader.js.map
